import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { PUR1030_R01DetailDto, PUR1030_R01Dto, PUR1030_R01HeaderDto } from './Dto_PUR1030_R01';
import { PUR1030_R01Filter } from "./Store_PUR1030_R01";

const baseUrl = `${config.apiUrl}/PUR1030_R01`;

const getParams = (filter: Partial<PUR1030_R01Filter>, listLength?: number) => {	
	return {
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		purchaseOrderNo: filter.purchaseOrderNo || undefined,
		customCd: filter.customCd || undefined,	
		orderStatus: filter.orderStatus || undefined,

		listLength: listLength || 0
	}
}

export const getPUR1030_R01List = async (option: string, params: Partial<PUR1030_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<PUR1030_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getPUR1030_R01AllCount = async (params: Partial<PUR1030_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getPUR1030_R01One = async (purchaseOrderNo: string) => {
	const url = `${baseUrl}/one/${purchaseOrderNo}`;
	return await getData<ResponseDto<PUR1030_R01HeaderDto>>(url);
}

export const getPUR1030_R01DetailList = async (purchaseOrderNo: string) => {
	const url = `${baseUrl}/detail/${purchaseOrderNo}`;

	return await getData<ResponseDto<PUR1030_R01DetailDto[]>>(url);
}

export const postPUR1030_R01 = async (data: PUR1030_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<PUR1030_R01Dto, ResponseDto<PUR1030_R01Dto[]>>(url, data);
}

export const patchPUR1030_R01 = async (data: PUR1030_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<PUR1030_R01Dto, ResponseDto<PUR1030_R01Dto[]>>(url, data);
}

export const deletePUR1030_R01 = async (purchaseOrderNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			purchaseOrderNo
		}
	});
}

export const downloadExcel_PUR1030_R01 = async (option: string, purchaseOrderNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			purchaseOrderNo
		}
	})
}
/** 발주전표 PDF Blob 반환 (출력은 Content에서 QZ/브라우저 폴백 처리) */
export const getPdfBlob_PUR1030_R01 = async (purchaseOrderNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { purchaseOrderNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};